import { withExtra } from '@koaly/with-extra';
import React from 'react';
import { ListItemBaseLi } from '../List/ListItemBase.js';
import { NavigationLink } from './NavigationLink.js';

const NavigationItem = withExtra(({ children, appearance, href, onClick, className, size, variant }, ref) => {
    return (React.createElement(ListItemBaseLi, { size: size },
        React.createElement(NavigationLink, { className: className, appearance: appearance, variant: variant, ref: ref, href: href, onClick: onClick }, children)));
}, { name: 'NavigationItem' });
NavigationItem.defaultProps = {
    variant: 'primary',
};

export { NavigationItem };
//# sourceMappingURL=NavigationItem.js.map
